/**
 * @flow
 * @author Box
 */

export type AiAgentTypeField = 'ai_agent_id';

export interface AiAgentReference {
    /**
     * AI Agent Reference to pass custom AI Agent ID to requests.
     * See https://developer.box.com/reference/resources/ai-agent-reference/
     */
    +type: AiAgentTypeField;
    +id: string;
}
